// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.725 21.992C27.031 20.797 26 17.416 26 13a10 10 0 0 0-20 0c0 4.418-1.032 7.797-1.726 8.992A2 2 0 0 0 6 25h5.101a5 5 0 0 0 9.798 0H26a2 2 0 0 0 1.725-3.008ZM16 27a3 3 0 0 1-2.828-2h5.655A2.999 2.999 0 0 1 16 27ZM6 23c.963-1.655 2-5.49 2-10a8 8 0 0 1 16 0c0 4.506 1.035 8.341 2 10H6Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
